<div class="kam-contact-info-component">
  <div class="title">{{ 'module.contact.personalAccountManagerGreetingsText' | translate }}</div>
  <div class="details">
    <div class="kam-image">
      <span *ngIf="imageSrc === null" class="fa fa-user-circle"></span>
      <img *ngIf="imageSrc" class="kam-pic" [src]="imageSrc" alt="your image" />
      <div class="imageLoading" *ngIf="isImageLoading">
        <span class="fa fa-spinner fa-spin fa-3x"></span>
      </div>
    </div>
    <div class="kam-contact-info">
      <div class="name">{{ kamUser ? kamUser.firstName : '' }} {{ kamUser ? kamUser.lastName : '' }}</div>
      <div class="department">{{ 'module.contact.contactDepartment' | translate }}</div>
      <div class="company">{{ kamUser ? kamUser.company : '' }}</div>
      <div *ngIf="kamUser && kamUser.textT">
        <span class="fa fa-phone"></span>
        <span class="label">T:</span>
        <span class="number" (click)="dialer(kamUser.textT)">{{ kamUser ? kamUser.textT : '' }}</span>
      </div>
      <div *ngIf="kamUser && kamUser.mobile">
        <span class="fa fa-lg fa-mobile"></span>
        <span class="label">M:</span>
        <span class="number" (click)="dialer(kamUser.mobile)">{{ kamUser ? kamUser.mobile : '' }}</span>
      </div>
      <div *ngIf="kamUser && kamUser.textF">
        <span class="fa fa-fax"></span>
        <span class="label">Fax:</span>
        <span class="number" (click)="dialer(kamUser.textF)">{{ kamUser ? kamUser.textF : '' }}</span>
      </div>
      <div class="email" *ngIf="kamUser && kamUser.email">
        <div class="fa fa-fax email-icon"></div>
        <div class="label email-label">E-Mail:</div>
        <div class="contact-email" (click)="mailer(kamUser.email)">{{ kamUser ? kamUser.email : '' }}</div>
      </div>
    </div>
  </div>

  <div *ngIf="isNotSuwag" class="bottom-container">
    <h4 class="profile-contact-label">{{ 'module.public.registration.contactText' | translate }}</h4>
    <h4 class="font-size-s font-weight-bold">Team EnergiePortal</h4>
    <h4 class="font-size-s dso-email-external" (click)="mailer()">{{ senderEmail }}</h4>
  </div>
</div>
